var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMassMedia = function SvgMassMedia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6a4.992 4.992 0 0 0-2 4c0 1.636.785 3.088 2 4m6 0a4.992 4.992 0 0 0 2-4 4.992 4.992 0 0 0-2-4m-3 5v10M6.6 3C4.413 4.596 3 7.138 3 10s1.414 5.404 3.6 7m10.8 0c2.186-1.596 3.6-4.138 3.6-7s-1.414-5.404-3.6-7",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 2,
    fill: "currentColor"
  })));
};
export default SvgMassMedia;